/**
 * usage_nudge_controller.js — dismiss the free-tier near-limit nudge (Stimulus).
 *
 * The banner (templates/components/banners/usage_banner.html) is server-rendered
 * by inject_usage_nudge() and refreshed live over Turbo Streams. Bootstrap's
 * data-bs-dismiss only removes the node for the current view, so it reappeared on
 * the next navigation. This controller instead records the dismissal in a cookie
 * keyed to the billing period; inject_usage_nudge() reads that cookie and stops
 * emitting the banner for the rest of the period. A new month has a new
 * period_key, so the nudge returns on the 1st — matching "It resets on the 1st".
 *
 * Wired in the template: data-controller="usage-nudge",
 * data-usage-nudge-period-value="<YYYY-MM>", button data-action="usage-nudge#dismiss".
 */
import { Controller } from "@hotwired/stimulus";

// ~40 days: comfortably past the next 1st-of-month reset, then self-expires so a
// stale cookie can never suppress a future period's nudge.
const DISMISS_MAX_AGE = 60 * 60 * 24 * 40;

export default class extends Controller {
    static values = { period: String };

    dismiss() {
        if (this.periodValue) {
            document.cookie = `usage_nudge_dismissed=${encodeURIComponent(this.periodValue)}` +
                `; path=/; max-age=${DISMISS_MAX_AGE}; samesite=lax`;
        }
        this.element.remove();
    }
}
